// extracted by mini-css-extract-plugin
export default {"body":"Movimientos_body__VBKTZ","content":"Movimientos_content__8sCyf","menuGroup":"Movimientos_menuGroup__Vh5US"};